/** @format */

import { createAction, props } from '@ngrx/store';
import { InventoryExceededStatus } from '@pdp/data-access/interfaces';

export type UserInputQuantitySource = 'qtyInput' | 'exceededInventory';

export const setUserInputQuantity = createAction(
	'[Add To Cart] Set User Input Quantity',
	props<{ atcUserInputQuantity: string; source: UserInputQuantitySource }>()
);

export const setATCFulfillmentOption = createAction(
	'[Add To Cart] Set ATC Fulfillment Option',
	props<{ atcFulfillmentOption: string }>()
);

export const setAirballInfo = createAction(
	'[Add To Cart] Set ATC Error/Success',
	props<{ success: boolean }>()
);

export const setFBTAirballInfo = createAction(
	'[Add To Cart] Set ATC Error/Success for Frequently Bought Together',
	props<{ success: boolean }>()
);

export const addProductToCart = createAction('[Add To Cart] Add Product To Cart');

export const resetAddToCartSuccessInfo = createAction(
	'[Add To Cart Success] Reset Add To Cart Success Info',
	props<{ message?: string; success: boolean }>()
);

export const resetAirballInfo = createAction(
	'[Snackbar] Reset Airball Info',
	props<{ message?: string; success: boolean }>()
);

export const requireOptionSelection = createAction('[Add To Cart] Require Option Selection');

export const setInventoryExceededStatus = createAction(
	'[Add To Cart] Set Inventory Exceeded Status',
	props<InventoryExceededStatus>()
);

export const setMaxOrMinQuantityAlert = createAction(
	'[Add To Cart] Set Max or Min Quantity Alert',
	props<{ message: string | null }>()
);
